import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const EditJobSkill = ({ editObj }) => {
  const [editObjData, setEditObjData] = useState([]);

  useEffect(() => {
    if (editObj) {
      setEditObjData(editObj);
    }
  }, [editObj]);

  return (
    <div>
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightEditReg"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "30%", maxWidth: "30%" }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Edit Category</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body">
          <form>
            <div className="content">
              <div className="row">
                <div className="col-12 mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={editObjData?.name}
                    onChange={(e) =>
                      setEditObjData({ ...editObjData, name: e.target.value })
                    }
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Description</label>
                  <textarea
                    type="text"
                    className="form-control"
                    value={editObjData?.description}
                    onChange={(e) =>
                      setEditObjData({
                        ...editObjData,
                        Description: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-secondary d-flex mt-3 me-2"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary d-flex mt-3"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

EditJobSkill.propTypes = {
  editObj: PropTypes.object.isRequired,
};

export default EditJobSkill;
